import { SSJBeaconButton, SSJBeaconInputField } from '../Beacon/Registry';
import React, { useEffect, useState } from 'react';
import debounce from 'lodash/debounce';
import { callApi, getEndpoint } from '../../../utils/api';
import search from '../../../assets/images/Search.svg';
import editIcon from '../../../assets/images/funding-edit.svg';

const AutoCompleteCustodians = (props) => {
  const [suggestions, setSuggestions] = useState([]);
  const [addManually, setAddManually] = useState(false);
  const [isInstTb, setIsInstTb] = useState(false);

  useEffect(() => {
    const mainList = document.getElementById('listbox');
    const listItems = document.querySelectorAll('suggestion');
    let currentIndex = -1;

    mainList?.addEventListener('keydown', (event) => {
      const key = event.key;

      if (key === 'ArrowUp' || key === 'ArrowDown') {
        event.preventDefault();

        if (currentIndex !== -1) {
          listItems[currentIndex].blur();
        }
      } else if (key === ' ') {
        event.preventDefault();
        if (currentIndex === -1) {
          event.target.click();
        }
      } else if (key === 'Enter') {
        if (currentIndex === -1) {
          event.target.click();
        }
      }
    });

    if (listItems.length > 0) {
      currentIndex = 0;
      listItems[currentIndex].focus();
    }
  }, [suggestions]);

  const debouncedApiCall = debounce(async (inputValue) => {
    try {
      const response = await callApi(getEndpoint('custodianInstitutions'));
      let institutions = response.body;
      institutions = institutions.filter((item) => {
        return item.custodianName
          .toLowerCase()
          .includes(inputValue.toLowerCase());
      });
      if (institutions) {
        setSuggestions(institutions);
      }
    } catch (e) {
      setAddManually(true);
    }
  }, 500);

  const handleInputChange = async (e) => {
    const value = e.target.value;
    if (value?.trim() === '') {
      props.setValues({
        ...props.values,
        externalFinancialInstituteName: '',
      });
      return false;
    }
    if (props.variant === 'rollover') {
      props.setValues({
        ...props.values,
        externalFinancialInstituteName: value,
      });
    }
    if (props.variant === 'transfer') {
      props.setValues({
        ...props.values,
        externalFinancialInstituteName: value,
      });
    }
    if (value.length >= 3 && addManually === false) {
      debouncedApiCall(value);
    } else {
      setSuggestions([]);
    }
  };

  const handleOnSuggClick = (custodian) => {
    if (props.variant === 'rollover' || props.variant === 'transfer') {
      if (props.variant === 'rollover') {
        props.setValues({
          ...props.values,
          externalFinancialInstituteName: custodian?.custodianName,
          csdId: custodian?.csdId,
          rolloverTopInstitution: custodian?.rolloverTopInstitution,
          transferTopInstitution: custodian?.transferTopInstitution,
        });
      }
      if (props.variant === 'transfer') {
        props.setValues({
          ...props.values,
          externalFinancialInstituteName: custodian?.custodianName,
          csdId: custodian?.csdId,
          rolloverTopInstitution: custodian?.rolloverTopInstitution,
          transferTopInstitution: custodian?.transferTopInstitution,
        });
      }
      setSuggestions([]);
      setIsInstTb(true);
    }
  };

  const handleOnClickAddManually = () => {
    setAddManually(true);
    setSuggestions([]);
  };

  const handleInstitutionType = () => {
    if (
      suggestions.length === 0 &&
      ((props.variant === 'rollover' &&
        props.values?.externalFinancialInstituteName !== '') ||
        (props.variant === 'transfer' &&
          props.values?.externalFinancialInstituteName !== ''))
    ) {
      setIsInstTb(true);
      if (props.variant === 'rollover') {
        props.setValues({
          ...props.values,
          externalFinancialInstituteName:
            props.values?.externalFinancialInstituteName,
        });
      }
      if (props.variant === 'transfer') {
        props.setValues({
          ...props.values,
          externalFinancialInstituteName:
            props.values?.externalFinancialInstituteName,
        });
      }
    }
  };

  const handleOnEditClick = () => {
    setAddManually(false);
    setIsInstTb(false);
    debouncedApiCall(props.values?.externalFinancialInstituteName);
  };

  return (
    <>
      {!isInstTb && (
        <div className="input-field">
          <SSJBeaconInputField
            id="externalFiName"
            label="External Financial Institution (Add Manually)"
            hint="Enter the full name of the financial institution holding your assets."
            onInput={(e) => handleInputChange(e)}
            name="externalFiName"
            icon-url={search}
            maxlength="35"
            icon-position="left"
            required="true"
            value={
              props.variant === 'rollover'
                ? props.values?.externalFinancialInstituteName
                : props.variant === 'transfer'
                ? props.values?.externalFinancialInstituteName
                : null
            }
            onBlur={handleInstitutionType}
            errors-map='{"required":"You must select your institution from the dropdown menu, or choose Add Manually"}'
          />
          {suggestions.length > 0 && (
            <ul className="suggestions" id="listbox">
              {suggestions.map((suggestion) => (
                <li key={`parentEl-${suggestion.csdId}`}>
                  <div
                    key={suggestion.csdId}
                    className="suggestion"
                    tabIndex="0"
                    value={suggestion}
                    onClick={() => handleOnSuggClick(suggestion)}
                  >
                    {suggestion.custodianName}
                  </div>
                  <div key={`line-${suggestion.csdId}`} className="line-thin" />
                </li>
              ))}
              <li key="sugQ" className="sug-question">
                Don't see your institution listed?
              </li>
              <li>
                <SSJBeaconButton
                  id="detials-submit-btn"
                  className="submit-btn"
                  label="+ Add Manually"
                  variant="tertiary"
                  onClick={handleOnClickAddManually}
                  errors-map='{"required":"You must provide the financial institution managing the assets"}'
                />
              </li>
            </ul>
          )}
        </div>
      )}

      {isInstTb && (
        <div className="details-wrapper">
          <div className="table">
            <div className="row">
              <div className="item">Financial Institution</div>
              <div className="content">
                <span>
                  {props.values?.externalFinancialInstituteName ||
                    props.values.externalFinancialInstituteName}
                </span>
                <div className="edit">
                  <SSJBeaconButton
                    scale="mini"
                    label="Edit"
                    variant="tertiary"
                    onClick={handleOnEditClick}
                    iconAlign="left"
                  >
                    <img
                      alt="edit-icon"
                      slot="icon"
                      width={16}
                      height={16}
                      className="transfer-account-details_transferFrom-details-second_edit-icon"
                      src={editIcon}
                    />
                  </SSJBeaconButton>
                </div>
              </div>
            </div>
            <div className="line-thin" />
          </div>
        </div>
      )}
    </>
  );
};

export default AutoCompleteCustodians;
